"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const responseError = require("./common/responseError");
const getUsers_1 = require("./getUsers");
const app_1 = require("./app");
const storeToken_1 = require("./storeToken");
const identifiers_1 = require("./identifiers");
const addDomain_1 = require("./addDomain");
const firebase = require("firebase");
/**
 * Handles signup/signin for all user roles
*/
function googleAuth(params) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const provider = new firebase.auth.GoogleAuthProvider();
            provider.addScope('email');
            provider.addScope('profile');
            const data = yield app_1.app.auth.signInWithPopup(provider);
            const { displayName, providerData, refreshToken, uid } = data.user;
            const { role } = params;
            let { domainId } = params;
            if (!domainId) {
                domainId = yield getDomainId(params, providerData);
            }
            const tokenData = {
                refreshToken,
                uid,
                name: displayName,
                email: providerData[0].email,
                providerId: providerData[0].providerId,
                domainId,
                role
            };
            return storeToken_1.default(tokenData, '');
        }
        catch (e) {
            throw new responseError.HttpsError(responseError.FunctionsErrorCode.invalid_argument, e.message);
        }
    });
}
exports.default = googleAuth;
function getDomainId(params, providerData) {
    return __awaiter(this, void 0, void 0, function* () {
        const { role } = params;
        const userDocs = yield getUsers_1.default({ email: providerData[0].email });
        // handle signin/signup conditions for each role
        let domainId = '';
        switch (role) {
            case identifiers_1.Types.UserPermissionRoles.TEACHER:
            case identifiers_1.Types.UserPermissionRoles.STUDENT:
                if (userDocs.length) { // if student/teacher is signing in
                    for (const permission of userDocs[0].permissions) {
                        // set domainId from permissions array for matching role
                        if (permission.role === role) {
                            domainId = permission.domainId;
                        }
                    }
                }
                else { // if student/teacher is signing up
                    const domainInfo = yield addDomain_1.default({ name: Math.random().toString(36).substring(7) });
                    domainId = domainInfo.id;
                }
                break;
            default:
                console.warn(`Couldn't set domainId for specified role : ${role}`);
                break;
        }
        return domainId;
    });
}
//# sourceMappingURL=googleAuth.js.map